module.exports = function(obj) {
obj || (obj = {});
var __t, __p = '';
with (obj) {
__p += '<div class="nei-banner">\r\n    <img src="' +
((__t = ( require('./images/contact-banner.jpg') )) == null ? '' : __t) +
'" />\r\n    <div class="title">联系我们</div>\r\n</div>';

}
return __p
}